import RequireAdmin from "/src/features/auth/hooks/requireAdmin";
import LogsTable from "/src/features/administration/logs/components/LogsTable/LogsTable";

function LogsList() {
    return (
        <RequireAdmin>
            <LogsTable />
        </RequireAdmin>
    );
}

export default LogsList;
